import {createFileRoute, redirect} from "@tanstack/react-router";
import {ErrorComponent} from "./-errorComponent";
import {NotFoundComponent} from "./-notFoundComponent";
import {PendingComponent} from "./-pendingComponent";
import {generateUuid, getCurrentIsoTimestamp} from "@vesta/global-common-typescript/utilities/utilities";
import {OnboardingJourneyStatus, OnboardingJourneyStep, type OnboardingJourney} from "~/domainModels/onboardingJourney";
import {getDataSourcesForFrontend, type DAG_DataSourceForFrontend} from "~/domainModels/dag/dataSources";
import {uniqueUuid} from "@vesta/unique/unique";
import {
    throwRedirectToConfigConnectDataSourcesWhenPresent,
    throwRedirectToConfigDataConnectionsWhenPresent,
} from "~/workspaceConfig/configOttosyncRedirects";

export const Route = createFileRoute("/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/w/$workspaceId/ottosync/")({
    beforeLoad: async ({context}) => {
        const dataSources = await context.queryClient.ensureQueryData<Array<DAG_DataSourceForFrontend>>({
            queryKey: [uniqueUuid`13358aac-6316-4545-b20e-e7219faeda91`, context.workspace.id],
            queryFn: async () => {
                const dataSourcesResult = await getDataSourcesForFrontend({
                    accessToken: context.authenticationStatus.accessToken,
                    intellsysBaseUrl: context.intellsysBaseUrl,
                    workspaceId: context.workspace.id,
                });
                if (dataSourcesResult.success !== true) {
                    throw dataSourcesResult.error;
                }
                return dataSourcesResult.data;
            },
            retry: false,
            staleTime: Infinity,
        });
        const totalDataSourceInstancesCount = dataSources.reduce((acc, dataSource) => acc + dataSource.dataSourceInstances.length, 0);
        if (totalDataSourceInstancesCount > 0) {
            throwRedirectToConfigDataConnectionsWhenPresent(context.workspace.id);
            throw redirect({
                to: "/w/$workspaceId/ottosync/data-sources",
                params: {
                    workspaceId: context.workspace.id,
                },
            });
        }

        const currentIsoTimestamp = getCurrentIsoTimestamp();
        const onboardingJourney: OnboardingJourney = {
            id: generateUuid(),
            createdAt: currentIsoTimestamp,
            updatedAt: currentIsoTimestamp,
            revisionId: generateUuid(),
            workspaceId: context.workspace.id,
            status: OnboardingJourneyStatus.active,
            currentStep: OnboardingJourneyStep.selectDataSources,
        };
        localStorage.setItem(`onboardingJourney/${onboardingJourney.id}`, JSON.stringify(onboardingJourney));

        throwRedirectToConfigConnectDataSourcesWhenPresent({
            workspaceId: context.workspace.id,
            onboardingJourneyId: onboardingJourney.id,
        });
        throw redirect({
            to: "/w/$workspaceId/ottosync/onboarding/connect-data-sources",
            params: {
                workspaceId: context.workspace.id,
            },
            search: {
                onboardingJourneyId: onboardingJourney.id,
            },
        });
    },
    loader: async () => {},
    errorComponent: ErrorComponent,
    pendingComponent: PendingComponent,
    notFoundComponent: NotFoundComponent,
});
